import { DWFileImport } from 'src/components/file-import';
import { registerExtComponent } from '@alife/cn-lowcode-utils';

registerExtComponent(DWFileImport.displayName, DWFileImport);

export default DWFileImport;
export { DWFileImport };
